import { User } from "../types/User";
import config from "../config";
import { requests } from ".";

const subdomainUser = "/users";

export const UserService = {
  getUsers: () => requests().get<{ users: User[] }>("/todos"),

  getUserById: async (userId: string) => {
    const { data } = await requests(config.MARKETPLACE_REST_API_URL).get(
      `${subdomainUser}/${userId}`
    );
    return data;
  },
};
